<script lang="ts">
    export let comparedTo: string
    export let keyDifferences: string
    export let vocabeoApproach: string[]
    export let comparedToApproach: string[]
    export let chooseVocabeoIf: string[]
    export let chooseComparedTo: string[]
    export let comparedToLink: string
    export let ifYou: string
</script>

<div class="comparison">
    <h1><img src="/logo_colors.svg" alt="logo" width="34" height="34"/>vocabeo vs {comparedTo}</h1>

    <section>
        <h2>Key Differences at a Glance</h2>
        <p>
            {@html keyDifferences}
        </p>
    </section>

    <section>
        <h2>Learning Approach Comparison</h2>
        <div class="approach-comparison">
            <div class="approach">
                <h3>vocabeo's approach</h3>
                <ul>
                    {#each vocabeoApproach as a}
                        <li>
                            {a}
                        </li>
                    {/each}
                </ul>
            </div>
            <div class="approach">
                <h3>{comparedTo}'s approach</h3>
                <ul>
                    {#each comparedToApproach as a}
                        <li>
                            {a}
                        </li>
                    {/each}
                </ul>
            </div>
        </div>
    </section>

    <section>
        <h2>Which One Suits You?</h2>
        <div class="which-one">
            <div>
                <h3>Choose Vocabeo If You:</h3>
                <ul>
                    {#each chooseVocabeoIf as a}
                        <li>
                            {a}
                        </li>
                    {/each}
                </ul>
            </div>
            <div>
                <h3>Choose {comparedTo} If You:</h3>
                <ul>
                    {#each chooseComparedTo as a}
                        <li>
                            {a}
                        </li>
                    {/each}
                </ul>
            </div>
        </div>
    </section>
    <section>
        <h2>Ready to Start Learning?</h2>
        <p>
            Now that you understand the key differences between <b>vocabeo</b> and {comparedTo}, you can choose the
            platform that best fits your learning style and goals.
        </p>
        <p>
            <b>vocabeo</b> sounds like a great fit? <a href="/browse" class="vocabeo-link"
                                                       style="background: var(--color-Pronoun);">» Browse</a> the
            dictionary
            and choose the words you like to learn or directly head over to <a href="/learn" class="vocabeo-link">»
            Learn</a> to start practicing.
        </p>
        <p>
            If you {ifYou},
            <a href={comparedToLink}
               rel="noreferrer noopener"
               target="_blank"
               class="compare-to-link"
            >
                {comparedTo}
            </a>
            might be what you're looking for.
        </p>
        <p>
            Whichever you choose, the key is consistency — so start learning today!
        </p>
        <a href="/comparison" class="back">« Back to comparison overview</a>
    </section>
</div>

<style>
    .comparison {
        display: grid;
        gap: var(--space-lg);
    }

    h1 {
        position: relative;
        font-size: 1.7rem;
        margin: 0 0 var(--space-sm) 0;
        justify-self: flex-start;
    }

    img {
        display: inline-block;
        margin-right: .3rem;
        transform: translateY(.1rem);
    }

    h2 {
        font-size: 1.4rem;
        margin: 0 0 var(--space-md);
    }

    h3 {
        margin: 0;
    }

    .approach-comparison,
    .which-one {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(18rem, 1fr));
        gap: .8rem 2rem;
    }

    ul {
        list-style: none;
        display: grid;
        gap: .6rem;
        margin: 0;
        padding: 1rem 0 1rem 1rem;
    }

    li {
        position: relative;
        font-size: .95rem;
    }

    li::before {
        position: absolute;
        top: 0;
        left: 0;
        transform: translate(calc(-100% - .2rem), -.1rem);
        content: '◼︎';
    }

    li:nth-child(1)::before {
        color: var(--color-Adverb);
    }

    li:nth-child(2)::before {
        color: var(--color-Adjective);
    }

    li:nth-child(3)::before {
        color: var(--color-Verb);
    }

    li:nth-child(4)::before {
        color: var(--color-Preposition);
    }

    li:nth-child(5)::before {
        color: var(--color-Num);
    }

    li:nth-child(6)::before {
        color: var(--color-Pronoun);
    }

    a {
        color: var(--color-main);
        text-decoration: revert;
    }

    a.compare-to-link {
        color: var(--color-Verb);
    }

    a.back {
        display: block;
        margin-top: var(--space-xl);
    }

    .vocabeo-link {
        display: inline-grid;
        place-content: center;
        background: var(--color-Verb);
        color: var(--text-on-color);
        padding: .2rem .4rem;
        border-radius: .2rem;
        line-height: 1;
        font-size: .95rem;
        text-decoration: none;
    }

    @media (max-width: 500px) {
        h1 {
            font-size: 1.6rem;
        }

        h2 {
            font-size: 1.3rem;
        }
    }
</style>